import { useState, useEffect, useCallback } from 'react'
import type { FulfillmentTaskDetail, TaskStatus } from '../types/fulfillment'
import { getPartnerTaskById, updateTaskStatus } from '../services/fulfillmentService'

export function useTaskDetail(taskId: string | undefined) {
  const [task, setTask] = useState<FulfillmentTaskDetail | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [updating, setUpdating] = useState(false)

  const fetchTask = useCallback(async () => {
    if (!taskId) return
    setLoading(true)
    setError(null)
    try {
      const result = await getPartnerTaskById(taskId)
      setTask(result)
    } catch (err: any) {
      setError(err?.message ?? 'Erro ao carregar pedido.')
    } finally {
      setLoading(false)
    }
  }, [taskId])

  useEffect(() => {
    fetchTask()
  }, [fetchTask])

  const changeStatus = useCallback(async (
    newStatus: TaskStatus,
    extra?: { trackingCode?: string; carrier?: string }
  ) => {
    if (!taskId) return
    setUpdating(true)
    try {
      await updateTaskStatus(taskId, newStatus, extra)
      await fetchTask()
    } catch (err: any) {
      throw err
    } finally {
      setUpdating(false)
    }
  }, [taskId, fetchTask])

  return { task, loading, error, updating, changeStatus, refetch: fetchTask }
}
